import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Gallery() {
  const [selectedCategory, setSelectedCategory] = useState('todos');
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [uploadMode, setUploadMode] = useState(false);
  const navigate = useNavigate();

  const categories = [
    { id: 'todos', name: 'Todos', icon: 'ri-gallery-line' },
    { id: 'cultos', name: 'Cultos', icon: 'ri-church-line' },
    { id: 'eventos', name: 'Eventos', icon: 'ri-calendar-event-line' },
    { id: 'batismos', name: 'Batismos', icon: 'ri-drop-line' },
    { id: 'casamentos', name: 'Casamentos', icon: 'ri-heart-line' },
    { id: 'criancas', name: 'Crianças', icon: 'ri-bear-smile-line' },
    { id: 'jovens', name: 'Jovens', icon: 'ri-group-line' },
    { id: 'missoes', name: 'Missões', icon: 'ri-earth-line' },
    { id: 'partituras', name: 'Partituras', icon: 'ri-music-line' },
    { id: 'personalizadas', name: 'Suas Fotos', icon: 'ri-user-add-line' }
  ];

  const photos = [
    {
      id: 1,
      title: 'Culto de Domingo - Manhã',
      category: 'cultos',
      date: '2024-01-14',
      description: 'Culto da família com grande participação dos irmãos',
      image: 'https://public.readdy.ai/ai/img_res/d72a33c6fe70ab7834102c1ff272fa91.jpg'
    },
    {
      id: 2,
      title: 'Batismo nas Águas',
      category: 'batismos',
      date: '2024-01-07',
      description: 'Celebração do batismo de 8 novos irmãos em Cristo',
      image: 'https://readdy.ai/api/search-image?query=Christian%20baptism%20ceremony%20in%20church%2C%20pastor%20baptizing%20person%20in%20water%2C%20joyful%20celebration%2C%20white%20robes%2C%20spiritual%20moment%2C%20congregation%20watching&width=400&height=300&seq=batismo-1&orientation=landscape'
    },
    {
      id: 3,
      title: 'Casamento Cristão - João e Maria',
      category: 'casamentos',
      date: '2023-12-16',
      description: 'Cerimônia de casamento abençoada por Deus',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20Christian%20wedding%20ceremony%20in%20church%2C%20bride%20and%20groom%20at%20altar%2C%20pastor%20officiating%2C%20flowers%2C%20elegant%20decoration%2C%20sacred%20moment&width=400&height=300&seq=casamento-1&orientation=landscape'
    },
    {
      id: 4,
      title: 'Escola Bíblica Infantil',
      category: 'criancas',
      date: '2024-01-13',
      description: 'Crianças aprendendo sobre Jesus com alegria',
      image: 'https://readdy.ai/api/search-image?query=Children%20Sunday%20school%20class%2C%20kids%20learning%20Bible%20stories%2C%20colorful%20classroom%2C%20teacher%20with%20children%2C%20happy%20faces%2C%20educational%20Christian%20environment&width=400&height=300&seq=escola-biblica-1&orientation=landscape'
    },
    {
      id: 5,
      title: 'Conferência de Jovens 2024',
      category: 'jovens',
      date: '2024-01-05',
      description: 'Jovens reunidos para adoração e palavra',
      image: 'https://readdy.ai/api/search-image?query=Youth%20Christian%20conference%2C%20young%20people%20worshipping%20with%20raised%20hands%2C%20modern%20church%20setting%2C%20energetic%20praise%2C%20contemporary%20worship%20atmosphere&width=400&height=300&seq=conferencia-jovens-1&orientation=landscape'
    },
    {
      id: 6,
      title: 'Culto de Ensino Bíblico',
      category: 'cultos',
      date: '2024-01-09',
      description: 'Terça-feira de ensino da Palavra de Deus',
      image: 'https://readdy.ai/api/search-image?query=Bible%20study%20class%20in%20church%2C%20pastor%20teaching%20from%20pulpit%2C%20congregation%20listening%20attentively%2C%20open%20Bibles%2C%20learning%20atmosphere%2C%20spiritual%20education&width=400&height=300&seq=ensino-biblico-1&orientation=landscape'
    },
    {
      id: 7,
      title: 'Missão Evangelística',
      category: 'missoes',
      date: '2023-12-20',
      description: 'Evangelização nas ruas de Caldas da Rainha',
      image: 'https://readdy.ai/api/search-image?query=Christian%20evangelism%20mission%2C%20church%20members%20sharing%20gospel%20on%20streets%2C%20friendly%20conversation%2C%20community%20outreach%2C%20spreading%20love%20and%20hope&width=400&height=300&seq=missao-evangelistica-1&orientation=landscape'
    },
    {
      id: 8,
      title: 'Festa de Natal 2023',
      category: 'eventos',
      date: '2023-12-24',
      description: 'Celebração do nascimento de Jesus Cristo',
      image: 'https://readdy.ai/api/search-image?query=Christmas%20celebration%20in%20church%2C%20nativity%20scene%2C%20Christmas%20tree%2C%20congregation%20celebrating%20birth%20of%20Jesus%2C%20festive%20decoration%2C%20joyful%20atmosphere&width=400&height=300&seq=festa-natal-1&orientation=landscape'
    },
    {
      id: 9,
      title: 'Culto da Vitória - Quinta',
      category: 'cultos',
      date: '2024-01-11',
      description: 'Quinta-feira de vitória e testemunhos',
      image: 'https://readdy.ai/api/search-image?query=Victory%20church%20service%2C%20people%20testifying%20and%20praising%20God%2C%20joyful%20worship%2C%20hands%20raised%20in%20celebration%2C%20spiritual%20victory%20atmosphere&width=400&height=300&seq=culto-vitoria-1&orientation=landscape'
    },
    {
      id: 10,
      title: 'Retiro Espiritual',
      category: 'eventos',
      date: '2023-11-25',
      description: 'Fim de semana de renovação espiritual',
      image: 'https://readdy.ai/api/search-image?query=Christian%20spiritual%20retreat%2C%20people%20praying%20in%20nature%2C%20peaceful%20outdoor%20setting%2C%20group%20prayer%2C%20spiritual%20renewal%2C%20serene%20atmosphere&width=400&height=300&seq=retiro-espiritual-1&orientation=landscape'
    },
    {
      id: 11,
      title: 'Apresentação Infantil',
      category: 'criancas',
      date: '2023-12-10',
      description: 'Crianças apresentando peça natalina',
      image: 'https://readdy.ai/api/search-image?query=Children%20Christmas%20play%20in%20church%2C%20kids%20in%20costumes%20performing%20nativity%20scene%2C%20proud%20parents%20watching%2C%20cute%20performance%2C%20holiday%20celebration&width=400&height=300&seq=apresentacao-infantil-1&orientation=landscape'
    },
    {
      id: 12,
      title: 'Vigília de Oração',
      category: 'eventos',
      date: '2023-12-31',
      description: 'Passagem de ano em oração e adoração',
      image: 'https://readdy.ai/api/search-image?query=New%20Year%20prayer%20vigil%20in%20church%2C%20people%20kneeling%20in%20prayer%2C%20candles%20lit%2C%20peaceful%20night%20worship%2C%20spiritual%20reflection%2C%20sacred%20atmosphere&width=400&height=300&seq=vigilia-oracao-1&orientation=landscape'
    }
  ];

  // Partituras de hinos e cânticos
  const sheetMusic = [
    {
      id: 'partitura-1',
      title: 'Quão Grande És Tu',
      category: 'partituras',
      date: '2024-01-15',
      description: 'Partitura completa do hino clássico',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20sheet%20music%20for%20Christian%20hymn%2C%20musical%20notes%20on%20staff%20paper%2C%20elegant%20typography%2C%20church%20music%20notation%2C%20traditional%20hymn%20arrangement&width=400&height=300&seq=partitura-1&orientation=landscape'
    },
    {
      id: 'partitura-2',
      title: 'Amazing Grace',
      category: 'partituras',
      date: '2024-01-12',
      description: 'Arranjo para coral e piano',
      image: 'https://readdy.ai/api/search-image?query=Amazing%20Grace%20sheet%20music%2C%20piano%20and%20choir%20arrangement%2C%20beautiful%20musical%20notation%2C%20classic%20hymn%20score%2C%20church%20music&width=400&height=300&seq=partitura-2&orientation=landscape'
    },
    {
      id: 'partitura-3',
      title: 'Rude Cruz',
      category: 'partituras',
      date: '2024-01-10',
      description: 'Hino tradicional com harmonia',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Christian%20hymn%20sheet%20music%2C%20four-part%20harmony%20notation%2C%20church%20choir%20music%2C%20elegant%20musical%20score%20layout&width=400&height=300&seq=partitura-3&orientation=landscape'
    },
    {
      id: 'partitura-4',
      title: 'Porque Ele Vive',
      category: 'partituras',
      date: '2024-01-08',
      description: 'Cântico de esperança e fé',
      image: 'https://readdy.ai/api/search-image?query=Contemporary%20Christian%20song%20sheet%20music%2C%20modern%20worship%20music%20notation%2C%20piano%20vocal%20arrangement%2C%20inspirational%20hymn%20score&width=400&height=300&seq=partitura-4&orientation=landscape'
    },
    {
      id: 'partitura-5',
      title: 'Santo, Santo, Santo',
      category: 'partituras',
      date: '2024-01-05',
      description: 'Hino de adoração clássico',
      image: 'https://readdy.ai/api/search-image?query=Holy%20holy%20holy%20hymn%20sheet%20music%2C%20traditional%20church%20music%20notation%2C%20worship%20song%20arrangement%2C%20sacred%20music%20score&width=400&height=300&seq=partitura-5&orientation=landscape'
    },
    {
      id: 'partitura-6',
      title: 'Jesus Me Ama',
      category: 'partituras',
      date: '2024-01-03',
      description: 'Cântico infantil simplificado',
      image: 'https://readdy.ai/api/search-image?query=Simple%20children%20Christian%20song%20sheet%20music%2C%20easy%20piano%20arrangement%2C%20kids%20church%20music%20notation%2C%20colorful%20musical%20score&width=400&height=300&seq=partitura-6&orientation=landscape'
    }
  ];

  // Placeholder para fotos personalizadas
  const customPhotos = [
    {
      id: 'custom-1',
      title: 'Adicionar Sua Foto',
      category: 'personalizadas',
      date: '',
      description: 'Clique para adicionar uma foto da sua igreja',
      image: '',
      isPlaceholder: true
    },
    {
      id: 'custom-2',
      title: 'Adicionar Sua Foto',
      category: 'personalizadas',
      date: '',
      description: 'Clique para adicionar uma foto da sua igreja',
      image: '',
      isPlaceholder: true
    },
    {
      id: 'custom-3',
      title: 'Adicionar Sua Foto',
      category: 'personalizadas',
      date: '',
      description: 'Clique para adicionar uma foto da sua igreja',
      image: '',
      isPlaceholder: true
    },
    {
      id: 'custom-4',
      title: 'Adicionar Sua Foto',
      category: 'personalizadas',
      date: '',
      description: 'Clique para adicionar uma foto da sua igreja',
      image: '',
      isPlaceholder: true
    },
    {
      id: 'custom-5',
      title: 'Adicionar Sua Foto',
      category: 'personalizadas',
      date: '',
      description: 'Clique para adicionar uma foto da sua igreja',
      image: '',
      isPlaceholder: true
    },
    {
      id: 'custom-6',
      title: 'Adicionar Sua Foto',
      category: 'personalizadas',
      date: '',
      description: 'Clique para adicionar uma foto da sua igreja',
      image: '',
      isPlaceholder: true
    }
  ];

  const allPhotos = [...photos, ...sheetMusic, ...customPhotos];

  const filteredPhotos = selectedCategory === 'todos' 
    ? [...photos, ...sheetMusic] // Não mostrar placeholders na visualização "todos"
    : selectedCategory === 'personalizadas'
    ? customPhotos
    : selectedCategory === 'partituras'
    ? sheetMusic
    : photos.filter(photo => photo.category === selectedCategory);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  const openModal = (imageUrl: string) => {
    if (imageUrl) {
      setSelectedImage(imageUrl);
    }
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handlePhotoUpload = () => {
    setUploadMode(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600">
      {/* Header Premium */}
      <header className="bg-white/98 backdrop-blur-lg shadow-2xl border-b-4 border-gradient-to-r from-emerald-600 to-teal-600">
        <div className="px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img 
                src="https://static.readdy.ai/image/8fbfc975813ef59021c9f16b313e86f9/f5810bc36c96b4c4a03e9a9aa341e507.png"
                alt="Assembleia de Deus - Missão Europa"
                className="w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 object-contain shadow-2xl rounded-2xl border-4 border-indigo-200"
              />
              <div className="text-center flex-1">
                <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent whitespace-nowrap">
                  <span style={{ fontFamily: '"Agnes", serif' }}>IGREJA AD MISSÃO EUROPA CHURCH</span>
                </h1>
                <p className="text-sm text-gray-600">Church Portugal</p>
              </div>
            </div>

            <nav className="flex items-center space-x-6">
              <button
                onClick={() => navigate('/home')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-home-line text-lg"></i>
                <span>Início</span>
              </button>

              <button
                onClick={() => navigate('/bible')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-book-line text-lg"></i>
                <span>Bíblia</span>
              </button>

              <button
                onClick={() => navigate('/characters')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-user-star-line text-lg"></i>
                <span>Personagens</span>
              </button>

              <button
                onClick={() => navigate('/radio')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-radio-line text-lg"></i>
                <span>Rádio</span>
              </button>

              <button
                onClick={() => navigate('/kids')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-bear-smile-line text-lg"></i>
                <span>Crianças</span>
              </button>

              <button
                onClick={() => navigate('/devotionals')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-heart-line text-lg"></i>
                <span>Devocionais</span>
              </button>

              <button
                onClick={() => navigate('/studies')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-graduation-cap-line text-lg"></i>
                <span>Estudos</span>
              </button>

              <button
                onClick={() => navigate('/prayer-requests')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-hands-line text-lg"></i>
                <span>Oração</span>
              </button>

              <button
                onClick={() => navigate('/gallery')}
                className="flex items-center space-x-2 px-6 py-3 text-emerald-600 bg-emerald-100 rounded-xl hover:bg-emerald-200 transition-all duration-200 whitespace-nowrap cursor-pointer font-medium shadow-lg"
              >
                <i className="ri-gallery-line text-lg"></i>
                <span>Mural</span>
              </button>

              <button
                onClick={() => navigate('/location')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-map-pin-line text-lg"></i>
                <span>Localização</span>
              </button>

              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-6 py-3 text-red-600 hover:bg-red-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-logout-box-line text-lg"></i>
                <span>Sair</span>
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Banner Premium */}
      <div className="relative h-96 bg-gradient-to-r from-emerald-800 via-teal-800 to-cyan-800 overflow-hidden">
        <div className="absolute inset-0 bg-black/40"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20church%20photo%20gallery%20wall%20with%20framed%20pictures%20of%20church%20events%2C%20warm%20lighting%2C%20community%20memories%2C%20family%20photos%2C%20spiritual%20moments%20captured%2C%20elegant%20display&width=1200&height=400&seq=gallery-banner-premium&orientation=landscape"
          alt="Mural da Igreja"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <h2 className="text-6xl font-bold mb-6 drop-shadow-2xl">🖼️ Mural da Igreja</h2>
            <p className="text-3xl opacity-95 mb-4 drop-shadow-lg">Momentos especiais da nossa comunidade</p>
            <p className="text-xl opacity-85 mb-3">Memórias que edificam nossa fé</p>
            <p className="text-lg opacity-75 mt-4 bg-black/30 px-6 py-2 rounded-full inline-block">✨ Adicione suas próprias fotos da igreja</p>
          </div>
        </div>
      </div>

      {/* Main Content Premium */}
      <div className="max-w-8xl mx-auto px-8 py-12">
        {/* Category Filter Premium */}
        <div className="bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/30 mb-12">
          <h3 className="text-3xl font-bold bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 bg-clip-text text-transparent mb-8">
            📸 Categorias
          </h3>
          <div className="flex flex-wrap gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex items-center space-x-3 px-8 py-4 rounded-2xl transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105 ${
                  selectedCategory === category.id
                    ? 'bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500 text-white shadow-2xl'
                    : 'bg-white text-gray-700 hover:bg-gradient-to-r hover:from-emerald-50 hover:to-teal-50 hover:text-emerald-700 shadow-lg hover:shadow-xl'
                }`}
              >
                <i className={`${category.icon} text-xl`}></i>
                <span className="font-bold text-lg">{category.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Photos Grid Premium */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {filteredPhotos.map((photo) => (
            <div
              key={photo.id}
              className="bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl overflow-hidden border border-white/30 hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
            >
              {photo.isPlaceholder ? (
                // Placeholder para fotos personalizadas
                <div
                  onClick={handlePhotoUpload}
                  className="aspect-[4/3] bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center cursor-pointer hover:from-emerald-50 hover:to-teal-50 transition-all duration-300"
                >
                  <div className="text-center">
                    <i className="ri-add-circle-line text-6xl text-gray-400 mb-4"></i>
                    <p className="text-xl font-bold text-gray-600">Adicionar Foto</p>
                    <p className="text-sm text-gray-500 mt-2">Clique para enviar</p>
                  </div>
                </div>
              ) : (
                <div
                  onClick={() => openModal(photo.image)}
                  className="aspect-[4/3] bg-gray-200 cursor-pointer overflow-hidden"
                >
                  <img
                    src={photo.image}
                    alt={photo.title}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
              )}
              
              <div className="p-6">
                <h4 className="text-xl font-bold text-gray-800 mb-3">{photo.title}</h4>
                <p className="text-gray-600 mb-4 leading-relaxed">{photo.description}</p>
                {photo.date && (
                  <div className="flex items-center space-x-2 text-sm text-gray-500">
                    <i className="ri-calendar-line"></i>
                    <span>{new Date(photo.date).toLocaleDateString('pt-BR')}</span>
                  </div>
                )}
                {photo.category === 'partituras' && (
                  <div className="mt-4">
                    <button className="w-full bg-gradient-to-r from-emerald-500 to-teal-500 text-white py-3 rounded-xl font-bold hover:from-emerald-600 hover:to-teal-600 transition-all duration-300 whitespace-nowrap cursor-pointer">
                      <i className="ri-download-line mr-2"></i>
                      Baixar Partitura
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Upload Section Premium */}
        {selectedCategory === 'personalizadas' && (
          <div className="mt-12 bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl p-10 border border-white/30">
            <h3 className="text-3xl font-bold bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 bg-clip-text text-transparent mb-8">
              📤 Adicionar Suas Fotos
            </h3>
            <div className="bg-gradient-to-r from-emerald-50 via-teal-50 to-cyan-50 border-2 border-dashed border-emerald-300 rounded-2xl p-12 text-center">
              <i className="ri-upload-cloud-line text-8xl text-emerald-500 mb-6"></i>
              <h4 className="text-2xl font-bold text-emerald-700 mb-4">Compartilhe Momentos da Igreja</h4>
              <p className="text-lg text-gray-700 mb-8">Adicione fotos dos cultos, eventos e atividades da sua igreja</p>
              <button
                onClick={handlePhotoUpload}
                className="bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500 text-white px-12 py-4 rounded-2xl font-bold text-xl hover:from-emerald-600 hover:via-teal-600 hover:to-cyan-600 transition-all duration-300 shadow-2xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-camera-line mr-3"></i>
                Selecionar Fotos
              </button>
              <p className="text-sm text-gray-500 mt-6">Formatos aceitos: JPG, PNG, GIF • Tamanho máximo: 10MB</p>
            </div>
          </div>
        )}

        {/* Statistics Premium */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/30 text-center">
            <i className="ri-image-line text-6xl text-emerald-500 mb-4"></i>
            <h4 className="text-3xl font-bold text-gray-800 mb-2">{photos.length}</h4>
            <p className="text-xl text-gray-600 font-medium">Fotos da Igreja</p>
          </div>
          <div className="bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/30 text-center">
            <i className="ri-music-line text-6xl text-teal-500 mb-4"></i>
            <h4 className="text-3xl font-bold text-gray-800 mb-2">{sheetMusic.length}</h4>
            <p className="text-xl text-gray-600 font-medium">Partituras Disponíveis</p>
          </div>
          <div className="bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/30 text-center">
            <i className="ri-folder-add-line text-6xl text-cyan-500 mb-4"></i>
            <h4 className="text-3xl font-bold text-gray-800 mb-2">{categories.length - 1}</h4>
            <p className="text-xl text-gray-600 font-medium">Categorias</p>
          </div>
        </div>
      </div>

      {/* Modal Premium */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-8">
          <div className="relative max-w-6xl max-h-full">
            <button
              onClick={closeModal}
              className="absolute -top-4 -right-4 bg-white text-gray-800 w-12 h-12 rounded-full flex items-center justify-center text-2xl font-bold hover:bg-gray-100 transition-all duration-200 shadow-2xl z-10 cursor-pointer"
            >
              ×
            </button>
            <img
              src={selectedImage}
              alt="Imagem ampliada"
              className="max-w-full max-h-full object-contain rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      )}
    </div>
  );
}
